module.exports = __webpack_public_path__ + "img/login_picture1.01cabaf6.png";